const routes = [
    {
        path: "/dashboard",
        component: () => import("../pages/Index"),
        meta: { isAuthenticated: true }
    }
];

export default routes;
